import {apiClient} from 'core/apiClient';
import {
    CreateFactory,
    CreateFactoryLine,
    EditFactoryRequestData,
    FactoriesListRawRow,
    Factory,
    FactoryLineStatisticsRecord,
    FactoryLineStatus,
} from 'types/profile';

import * as fakeApi from '../fakeApi';

const PROFILE_URL = '/service/profile';

export async function fetchFactoriesList(): Promise<FactoriesListRawRow[]> {
    const path = `${PROFILE_URL}/factories`;
    return (await apiClient.get(path)).data as FactoriesListRawRow[];
}

export async function fetchFactory(id: string): Promise<Factory> {
    const path = `${PROFILE_URL}/factories/${id}`;
    return (await apiClient.get(path)).data as Factory;
}

export async function fetchFactoryLinesList(id: string): Promise<FactoryLineStatus[]> {
    const path = `${PROFILE_URL}/factories/${id}/factory-lines`;
    return (await apiClient.get(path)).data as FactoryLineStatus[];
}

export async function fetchFactoryLine(params: {factoryId: string; lineId: string}): Promise<any> {
    const path = `${PROFILE_URL}/factories/${params.factoryId}/factory-lines/${params.lineId}`;
    return (await apiClient.get(path)).data;
}

export async function fetchFactoryLineDynamicStatistics(params: {
    id: number;
    from: Date;
    to: Date;
}): Promise<FactoryLineStatisticsRecord[]> {
    return (await fakeApi.fetchFactoryLineDynamicStatistics(
        params.id,
        params.from,
        params.to,
    )) as FactoryLineStatisticsRecord[];
}

export async function createFactory(params: {
    name: string;
    code: string;
    address: string;
}): Promise<any> {
    const path = `${PROFILE_URL}/factories/`;
    return (await apiClient.post(path, params)).data;
}

export async function createFactoriesBatch(params: {
    factories: CreateFactory[];
}): Promise<FactoriesListRawRow[]> {
    const path = `${PROFILE_URL}/factories/batch-add`;
    return (await apiClient.post(path, params)).data;
}

export async function editFactory(params: {
    id: number;
    data: EditFactoryRequestData;
}): Promise<any> {
    const path = `${PROFILE_URL}/factories/${params.id}/batch-update`;
    return (await apiClient.put(path, params.data)).data;
}

export async function createFactoryLine(params: {
    name: string;
    code: string;
    factoryId: string;
}): Promise<any> {
    const path = `${PROFILE_URL}/factories/${params.factoryId}/factory-lines`;
    return (await apiClient.post(path, {name: params.name, code: params.code, productName: 'Test'}))
        .data;
}

export async function createFactoryLinesBatch(params: {
    factoryId: string;
    factoryLines: CreateFactoryLine[];
}): Promise<FactoriesListRawRow[]> {
    const path = `${PROFILE_URL}/factories/${params.factoryId}/factory-lines/batch-add`;
    const {factoryLines} = params;
    return (await apiClient.post(path, {factoryLines})).data;
}
